import React, { useState, useEffect } from "react";
import { SubHeader } from "components/SubHeader";
import { api } from "services/api";
import Swal from "sweetalert2";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Input } from "components/Input";
import { Image } from "components/Image";
import ReactLoading from "react-loading";
import { ViewLoader } from "components/ViewLoader";
import { Icons } from "components/Icons";
import {
  Block,
  BlockBody,
  BlockHeader,
  Group,
  Card,
  CardBody,
  CardHeader,
  Col,
} from "styles";
import { Row } from "./style";
import { Body, Header, TableContent } from "components/Table/style";
import { Button } from "components/Button";

export function Production(props) {
  const initialInputId = (label) => ({
    new: {
      score: "",
      description: "",
      img: {
        files: [],
        fileName: "",
      },
      loading: false,
      points: "",
    },
    edit: {
      score: "",
      description: "",
      img: {
        files: [],
        fileName: "",
      },
      _id: "",
      loading: false,
      points: "",
    },
    label,
  });

  const [inputs, setInputs] = useState({
    feces: {
      meggProductionFeces: initialInputId("Fezes"),
    },
    environment: {
      meggProductionExternalCleaning: initialInputId("Limpeza Externa"),
      meggProductionInternalCleaning: initialInputId("Limpeza Interna"),
      meggProductionVentilationSystem: initialInputId("Sistema de Ventilação"),
      meggProductionNebulizationSystem: initialInputId(
        "Sistema de Nebulização"
      ),
      meggProductionLuxLighting: initialInputId("Iluminação Lux"),
      meggProductionFootbathPresence: initialInputId("Presença Pedilúvio"),
      meggProductionExclusiveFootwearUse: initialInputId("Uso Propé"),
      meggProductionDeadBirdsUse: initialInputId("Aves Mortes (decomposição)"),
      meggProductionChlorinatedWaterUse: initialInputId(
        "Água Clorada (2-4 ppm)"
      ),
    },

    sanity: {
      meggProductionVivacity: initialInputId("Vivacidade"),
      meggProductionExcreteQuality: initialInputId("Qualidade de Excreta"),
      meggProductionLice: initialInputId("Piolhos"),
      meggProductionRuffledFeathers: initialInputId("Penas Eriçadas"),
      meggProductionSnore: initialInputId("Ronqueira"),
      meggProductionSneeze: initialInputId("Espirro"),
      meggProductionCoryza: initialInputId("Coriza"),
      meggProductionSwollenHead: initialInputId("Cabeça Inchada"),
    },
    integument: {
      meggProductionOralInjury: initialInputId("Lesão Oral"),
      meggProductionMuscleHemorrhage: initialInputId("Hemorragia Muscular"),
      meggProductionAbdominalFat: initialInputId("Gordura Abdominal"),
      meggProductionFemurHeadNecrosis: initialInputId("Necrose da Cab. Femur"),
    },
    respiratorySystem: {
      meggProductionAerosaculite: initialInputId("Aerossaculite"),
      meggProductionParanasalSinuses: initialInputId("Seios Paranasais"),
      meggProductionNasalDischarge: initialInputId("Secreção Nasal"),
      meggProductionTracheitis: initialInputId("Traqueite"),
    },
    immuneSystem: {
      meggProductionSuffusions: initialInputId("Sufusões"),
      meggProductionPeyerPlate: initialInputId("Placa de Peyer"),
      meggProductionHemorrhagicCecalTonsils: initialInputId(
        "tonsilas Cecais Hemorrágicas"
      ),
    },
    digestiveSystem: {
      meggProductiongizzardErosion: initialInputId("Erosão de Moela"),
      meggProductionPancreasAtrophy: initialInputId("Atrofia de Pâncreas"),
      meggProductionDuodenitis: initialInputId("Duodenite"),
      meggProductionLiver: initialInputId("Fígado"),
      meggProductionIntestinalTone: initialInputId("Tônus Intestinal"),
      meggProductionIntestinalWallThickness: initialInputId(
        "Espessura da parede intestinal"
      ),
      meggProductionFluidContent: initialInputId("Conteúdo Fluido"),
      meggProductionMucusPresence: initialInputId("Presença de Muco"),
      meggProductionPresenceOfBile: initialInputId("Presença de Bile"),
      meggProductionFlatWorms: initialInputId("Vermes chatos"),
      meggProductionNecroticEnteritis: initialInputId("Enterite Necrótica"),
      meggProductionFoodPass: initialInputId("Passagem de Alimento"),
      meggProductionCellPeeling: initialInputId("Descamação Celular"),
      meggProductionIntestinalgas: initialInputId("Gás intestinal"),
      meggProductionHyperemia: initialInputId("Hiperemia (vermelhidão)"),
      meggProductionCecalGas: initialInputId("Gás cecal"),
    },
    reproductiveSystem: {
      meggProductionFollicleFormation: initialInputId("Formação De Foliculos"),
      meggProductionAtresicFollicle: initialInputId("Foliculo Atrésico"),
    },
  });

  const [configs, setConfigs] = useState([]);

  const [getConfigs, setGetConfigs] = useState(true);

  const [loadRemove, setLoadRemove] = useState("");

  const [loading, setLoading] = useState(true);

  const [tab, setTab] = useState(0);

  const setEdit = (key, { score, description, _id, points }) => {
    const keys = key.split(".");
    const copyInputs = JSON.parse(JSON.stringify(inputs));
    copyInputs[keys[0]][keys[1]].edit._id = _id;
    copyInputs[keys[0]][keys[1]].edit.score = score;
    copyInputs[keys[0]][keys[1]].edit.description = description;
    copyInputs[keys[0]][keys[1]].edit.points = points;
    setInputs(copyInputs);
  };

  const cancelEdit = (key) => {
    const keys = key.split(".");
    const copyInputs = JSON.parse(JSON.stringify(inputs));
    copyInputs[keys[0]][keys[1]].edit = {
      score: "",
      description: "",
      img: {
        files: [],
        fileName: "",
      },
      _id: "",
      points: "",
      loading: false,
    };
    setInputs(copyInputs);
  };

  const removeItem = async (config) => {
    const result = await Swal.fire({
      text: "Deseja remover o item",
      title: "remover Item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0451e8",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, Remover item!",
    });
    if (result.value) {
      setLoadRemove(config._id);
      const response = await api
        .delete("necropsyconfig", {
          data: { id: config._id },
        })
        .catch((err) => ({
          err: true,
          data: { message: err.response.data.message },
        }));
      setLoadRemove("");
      setGetConfigs(true);
      if (response.err) {
        return Swal.fire("remover Item", "Erro ao remover item", "error");
      }
      await api.delete("fileUpload", {
        data: {
          id: `necropsy-${config.key.replace(/\./g, "-")}-${config.score}.${
            config.extention
          }`,
        },
      });
    }
  };

  const saveItem = async (key, input, edit = false) => {
    const keys = key.split(".");
    let copyInputs = JSON.parse(JSON.stringify(inputs));
    const param = edit ? "edit" : "new";
    const request = edit ? "put" : "post";
    copyInputs[keys[0]][keys[1]][param].loading = true;
    setInputs(copyInputs);
    const { score, description, _id, points } = input[param];
    const { fileName, files } = input[param].img;
    const extention = files[0]
      ? fileName.split(".")[fileName.split(".").length - 1]
      : "";
    const data = {
      key,
      score,
      description,
      points,
    };
    if (extention) {
      data.extention = extention;
    }
    const response = await api[request](
      `necropsyconfig${edit ? "/" + _id : ""}`,
      data
    ).catch((err) => ({
      err: true,
      data: { message: err.response.data.message },
    }));

    if (response.err) {
      copyInputs = JSON.parse(JSON.stringify(inputs));
      copyInputs[keys[0]][keys[1]][param].loading = false;
      setInputs(copyInputs);
      return Swal.fire(
        `${edit ? "Edit" : "Add"} Item`,
        response.data.message,
        "error"
      );
    }

    if (files[0]) {
      const formData = new FormData();
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append(
        "file",
        files[0],
        `necropsy-${key.replace(/\./g, "-")}-${response.data.id}.${extention}`
      );
      const responseImage = await api
        .post("fileUpload", formData, config)
        .catch((err) => ({
          err: true,
          data: { message: err.response.data.message },
        }));

      if (responseImage.err) {
        Swal.fire(
          "Enviar Imagem",
          "Não foi possível salvar a imagem",
          "warning"
        );
      }
    }
    copyInputs = JSON.parse(JSON.stringify(inputs));
    copyInputs[keys[0]][keys[1]] = initialInputId(
      inputs[keys[0]][keys[1]].label
    );
    setInputs(copyInputs);
    setGetConfigs(true);
  };

  const necropsyConfigsLoader = (key) => {
    const params = key.split(".");
    const input = inputs[params[0]][params[1]];
    return (
      <Col>
        <Card>
          <CardHeader>{input.label}</CardHeader>
          <CardBody>
            <TableContent>
              <Header>
                <tr>
                  <th style={{ width: "100px" }}>Score</th>
                  <th>Descrição</th>
                  <th style={{ width: "92px" }}>Pontos</th>
                  <th style={{ width: "150px" }}>Imagem</th>
                  <th></th>
                </tr>
              </Header>
              <Body>
                {configs
                  .filter((config) => config.key === key)
                  .map((config) =>
                    input.edit._id === config._id ? (
                      <tr key={config._id}>
                        <td>
                          <Input
                            item={inputs}
                            setItem={setInputs}
                            params={`${key}.edit.score`}
                            type="inputOnly"
                            placeholder="Score"
                          />
                        </td>
                        <td>
                          <Input
                            item={inputs}
                            setItem={setInputs}
                            params={`${key}.edit.description`}
                            type="inputOnly"
                            placeholder="Descrição"
                          />
                        </td>
                        <td>
                          <Input
                            inputType="number"
                            item={inputs}
                            setItem={setInputs}
                            params={`${key}.edit.points`}
                            type="inputOnly"
                            placeholder="Pontos"
                          />
                        </td>
                        <td>
                          <Input
                            type="inputFile"
                            item={inputs}
                            setItem={setInputs}
                            params={`${key}.edit.img`}
                            accept="image/*"
                            placeholder="imagem"
                          />
                        </td>
                        <td>
                          {input.edit.loading ? (
                            <ReactLoading
                              type="spin"
                              color="#009870"
                              height={30}
                              width={30}
                            />
                          ) : (
                            <Group>
                              <Button
                                type="button"
                                bg="basf"
                                border="basf"
                                color="white"
                                onClick={() => saveItem(key, input, true)}
                              >
                                <Icons type="edit" color="#FFF" size={15} />
                              </Button>
                              <Button
                                type="button"
                                bg="light"
                                border="secondary"
                                color="secondary"
                                onClick={() => cancelEdit(key)}
                              >
                                <Icons type="close" color="#7E8299" size={15} />
                              </Button>
                            </Group>
                          )}
                        </td>
                      </tr>
                    ) : (
                      <tr key={config._id}>
                        <td>{config.score}</td>
                        <td>{config.description}</td>
                        <td>
                          {config.points ? config.points.toLocaleString() : 0}
                        </td>
                        <td>
                          <Image
                            src={`https://zenbytes-public.sfo2.digitaloceanspaces.com/mcassab/necropsy-${config.key.replace(
                              /\./g,
                              "-"
                            )}-${config._id}.${config.extention}`}
                          />
                        </td>
                        <td>
                          {loadRemove === config._id ? (
                            <ReactLoading
                              type="spin"
                              color="#009870"
                              height={30}
                              width={30}
                            />
                          ) : (
                            <Group>
                              <Button
                                type="button"
                                bg="basf"
                                border="basf"
                                color="white"
                                onClick={() => setEdit(key, config)}
                              >
                                <Icons type="edit" color="#FFF" size={15} />
                              </Button>
                              <Button
                                type="button"
                                bg="danger"
                                border="danger"
                                color="white"
                                onClick={() => removeItem(config)}
                              >
                                <Icons type="trash" color="#FFF" size={15} />
                              </Button>
                            </Group>
                          )}
                        </td>
                      </tr>
                    )
                  )}
                <tr>
                  <td>
                    <Input
                      item={inputs}
                      setItem={setInputs}
                      params={`${key}.new.score`}
                      type="inputOnly"
                      placeholder="Score"
                      disabled={input.new.loading}
                    />
                  </td>
                  <td>
                    <Input
                      item={inputs}
                      setItem={setInputs}
                      params={`${key}.new.description`}
                      type="inputOnly"
                      placeholder="Descrição"
                      disabled={input.new.loading}
                    />
                  </td>
                  <td>
                    <Input
                      inpuType="number"
                      item={inputs}
                      setItem={setInputs}
                      params={`${key}.new.points`}
                      type="inputOnly"
                      placeholder="Pontos"
                      disabled={input.new.loading}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputFile"
                      item={inputs}
                      setItem={setInputs}
                      params={`${key}.new.img`}
                      accept="image/*"
                      placeholder="Imagem"
                      disabled={input.new.loading}
                    />
                  </td>
                  <td>
                    {input.new.loading ? (
                      <ReactLoading
                        type="spin"
                        color="#009870"
                        height={30}
                        width={30}
                      />
                    ) : (
                      <Button
                        type="button"
                        bg="default"
                        border="default"
                        color="white"
                        onClick={() => saveItem(key, input)}
                      >
                        <Icons type="save" color="#FFF" size={15} />
                      </Button>
                    )}
                  </td>
                </tr>
              </Body>
            </TableContent>
          </CardBody>
        </Card>
      </Col>
    );
  };

  useEffect(() => {
    const loadConfigs = async () => {
      const response = await api.get("necropsyconfig");
      setConfigs(response.data);
      setLoading(false);
    };
    if (getConfigs) {
      setGetConfigs(false);
      loadConfigs();
    }
  }, [getConfigs]);

  return (
    <>
      <ViewLoader isLoading={loading} />
      <SubHeader
        {...props}
        title="Pré-Necropsia"
        breadcrumbs={[
          { label: "Configuração" },
          {
            label: "MEgg",
          },
          {
            label: "Pré-Necropsia",
          },
        ]}
        icon={<Icons type="preNecropsy" size="24" color="#fff" />}
      />
      {!loading && (
        <Block className="animate__animated animate__fadeInUp">
          <BlockHeader>
            <Tabs
              value={tab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, value) => {
                setTab(value);
              }}
            >
              <Tab label="Qualidade de Fezes" />
              <Tab label="Ambiente" />
              <Tab label="Sanidade" />
              <Tab label="Tegumentar" />
              <Tab label="Respiratório" />
              <Tab label="Imunológico" />
              <Tab label="Digestório" />
              <Tab label="Reprodutivo" />
            </Tabs>
          </BlockHeader>
          {tab === 0 && (
            <BlockBody>
              <Row>{necropsyConfigsLoader("feces.meggProductionFeces")}</Row>
            </BlockBody>
          )}
          {tab === 1 && (
            <BlockBody>
              <Row>
                {necropsyConfigsLoader(
                  "environment.meggProductionExternalCleaning"
                )}
                {necropsyConfigsLoader(
                  "environment.meggProductionInternalCleaning"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "environment.meggProductionVentilationSystem"
                )}
                {necropsyConfigsLoader("environment.meggProductionLuxLighting")}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "environment.meggProductionFootbathPresence"
                )}
                {necropsyConfigsLoader(
                  "environment.meggProductionExclusiveFootwearUse"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "environment.meggProductionNebulizationSystem"
                )}
                {necropsyConfigsLoader(
                  "environment.meggProductionDeadBirdsUse"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "environment.meggProductionChlorinatedWaterUse"
                )}
              </Row>
            </BlockBody>
          )}
          {tab === 2 && (
            <BlockBody>
              <Row>
                {necropsyConfigsLoader("sanity.meggProductionVivacity")}
                {necropsyConfigsLoader("sanity.meggProductionExcreteQuality")}
              </Row>
              <Row>
                {necropsyConfigsLoader("sanity.meggProductionLice")}
                {necropsyConfigsLoader("sanity.meggProductionSnore")}
              </Row>
              <Row>
                {necropsyConfigsLoader("sanity.meggProductionSneeze")}
                {necropsyConfigsLoader("sanity.meggProductionCoryza")}
              </Row>
              <Row>
                {necropsyConfigsLoader("sanity.meggProductionSwollenHead")}
                {necropsyConfigsLoader("sanity.meggProductionRuffledFeathers")}
              </Row>
            </BlockBody>
          )}
          {tab === 3 && (
            <BlockBody>
              <Row>
                {necropsyConfigsLoader("integument.meggProductionOralInjury")}
                {necropsyConfigsLoader(
                  "integument.meggProductionMuscleHemorrhage"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader("integument.meggProductionAbdominalFat")}
                {necropsyConfigsLoader(
                  "integument.meggProductionFemurHeadNecrosis"
                )}
              </Row>
            </BlockBody>
          )}
          {tab === 4 && (
            <BlockBody>
              <Row>
                {necropsyConfigsLoader(
                  "respiratorySystem.meggProductionAerosaculite"
                )}
                {necropsyConfigsLoader(
                  "respiratorySystem.meggProductionParanasalSinuses"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "respiratorySystem.meggProductionNasalDischarge"
                )}
                {necropsyConfigsLoader(
                  "respiratorySystem.meggProductionTracheitis"
                )}
              </Row>
            </BlockBody>
          )}
          {tab === 5 && (
            <BlockBody>
              <Row>
                {necropsyConfigsLoader("immuneSystem.meggProductionSuffusions")}
                {necropsyConfigsLoader("immuneSystem.meggProductionPeyerPlate")}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "immuneSystem.meggProductionHemorrhagicCecalTonsils"
                )}
              </Row>
            </BlockBody>
          )}
          {tab === 6 && (
            <BlockBody>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductiongizzardErosion"
                )}
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionPancreasAtrophy"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionDuodenitis"
                )}
                {necropsyConfigsLoader("digestiveSystem.meggProductionLiver")}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionIntestinalTone"
                )}
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionIntestinalWallThickness"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionFluidContent"
                )}
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionMucusPresence"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionPresenceOfBile"
                )}
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionFlatWorms"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionNecroticEnteritis"
                )}
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionFoodPass"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionCellPeeling"
                )}
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionIntestinalgas"
                )}
              </Row>
              <Row>
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionHyperemia"
                )}
                {necropsyConfigsLoader(
                  "digestiveSystem.meggProductionCecalGas"
                )}
              </Row>
            </BlockBody>
          )}
          {tab === 7 && (
            <BlockBody>
              <Row>
                {necropsyConfigsLoader(
                  "reproductiveSystem.meggProductionFollicleFormation"
                )}
                {necropsyConfigsLoader(
                  "reproductiveSystem.meggProductionAtresicFollicle"
                )}
              </Row>
            </BlockBody>
          )}
        </Block>
      )}
    </>
  );
}
